import { render, staticRenderFns } from "./IndexView.vue?vue&type=template&id=c7ca610a&scoped=true&"
import script from "./IndexView.vue?vue&type=script&lang=js&"
export * from "./IndexView.vue?vue&type=script&lang=js&"
import style0 from "./IndexView.vue?vue&type=style&index=0&id=c7ca610a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ca610a",
  null
  
)

export default component.exports